// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { structNodestUrl } from "../../const";

export const topicsApi = createApi({
  reducerPath: "topicsApi",
  baseQuery: fetchBaseQuery({ baseUrl: structNodestUrl }),
  endpoints: (builder) => ({
    getStructNodes: builder.query({
      query: (params) => ({
        url: "/getStructNodes",
        params
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetStructNodesQuery, useLazyGetStructNodesQuery } = topicsApi;
